import { Checkbox } from "@chakra-ui/react";
import { translate } from "../../../i18n";

type Props = { selected: boolean; setSelected: (newValue: boolean) => void; }
export default function CalendarCheckboxShowAllDay({ selected, setSelected }: Props) {
    return (
        <Checkbox
            isChecked={selected}
            onChange={(e) => setSelected(e.target.checked)}
        >
            {translate('calendar.show_all_day')}
        </Checkbox>
    )
}
